export const Meeting = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="white" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.65662 10.7812C5.65662 10.0059 5.02576 9.375 4.25037 9.375C3.47498 9.375 2.84412 10.0059 2.84412 10.7812C2.84412 11.5566 3.47498 12.1875 4.25037 12.1875C5.02576 12.1875 5.65662 11.5566 5.65662 10.7812Z"
        fill="#242424"
        {...props}
      />
      <path
        d="M9.40662 10.7812C9.40662 10.0059 8.77576 9.375 8.00037 9.375C7.22498 9.375 6.59412 10.0059 6.59412 10.7812C6.59412 11.5566 7.22498 12.1875 8.00037 12.1875C8.77576 12.1875 9.40662 11.5566 9.40662 10.7812Z"
        fill="#242424"
        {...props}
      />
      <path
        d="M13.1566 10.7812C13.1566 10.0059 12.5258 9.375 11.7504 9.375C10.975 9.375 10.3441 10.0059 10.3441 10.7812C10.3441 11.5566 10.975 12.1875 11.7504 12.1875C12.5258 12.1875 13.1566 11.5566 13.1566 10.7812Z"
        fill="#242424"
        {...props}
      />
      <path
        d="M12.6879 12.1875H10.8129C10.453 12.1875 10.1244 12.3236 9.87537 12.5468C9.62634 12.3236 9.29773 12.1875 8.93787 12.1875H7.06287C6.703 12.1875 6.37439 12.3236 6.12537 12.5468C5.87634 12.3236 5.54773 12.1875 5.18787 12.1875H3.31287C2.53748 12.1875 1.90662 12.8184 1.90662 13.5937V15.5312C1.90662 15.7902 2.11646 16 2.37537 16H13.6254C13.8843 16 14.0941 15.7902 14.0941 15.5312V13.5937C14.0941 12.8184 13.4633 12.1875 12.6879 12.1875Z"
        fill="#242424"
        {...props}
      />
      <path
        d="M3.78162 6.09375C3.78162 5.31836 3.15076 4.6875 2.37537 4.6875C1.59998 4.6875 0.969116 5.31836 0.969116 6.09375C0.969116 6.86914 1.59998 7.5 2.37537 7.5C3.15076 7.5 3.78162 6.86914 3.78162 6.09375Z"
        fill="#242424"
        {...props}
      />
      <path
        d="M7.53162 6.09375C7.53162 5.31836 6.90076 4.6875 6.12537 4.6875C5.34998 4.6875 4.71912 5.31836 4.71912 6.09375C4.71912 6.86914 5.34998 7.5 6.12537 7.5C6.90076 7.5 7.53162 6.86914 7.53162 6.09375Z"
        fill="#242424"
        {...props}
      />
      <path
        d="M11.2816 6.09375C11.2816 5.31836 10.6508 4.6875 9.87537 4.6875C9.09998 4.6875 8.46912 5.31836 8.46912 6.09375C8.46912 6.86914 9.09998 7.5 9.87537 7.5C10.6508 7.5 11.2816 6.86914 11.2816 6.09375Z"
        fill="#242424"
        {...props}
      />
      <path
        d="M15.0629 6.09375C15.0629 5.71594 14.9083 5.36023 14.6278 5.09204C14.355 4.83118 13.9989 4.6875 13.6254 4.6875C12.85 4.6875 12.2191 5.31836 12.2191 6.09375C12.2191 6.86914 12.85 7.5 13.6254 7.5C13.9989 7.5 14.355 7.35632 14.6278 7.09546C14.9083 6.82727 15.0629 6.47156 15.0629 6.09375Z"
        fill="#242424"
        {...props}
      />
      <path
        d="M14.5941 7.5H12.6879C12.328 7.5 11.9994 7.63611 11.7504 7.85925C11.5013 7.63611 11.1727 7.5 10.8129 7.5H8.93787C8.578 7.5 8.24939 7.63611 8.00037 7.85925C7.75134 7.63611 7.42273 7.5 7.06287 7.5H5.18787C4.828 7.5 4.49939 7.63611 4.25037 7.85925C4.00134 7.63611 3.67273 7.5 3.31287 7.5H1.40662C0.631226 7.5 0.000366211 8.13086 0.000366211 8.90625V10.7812C0.000366211 11.0402 0.210205 11.25 0.469116 11.25H1.95374C1.92285 11.0985 1.90662 10.9418 1.90662 10.7812C1.90662 9.48889 2.95801 8.4375 4.25037 8.4375C5.01624 8.4375 5.69739 8.80676 6.12537 9.37659C6.55334 8.80676 7.2345 8.4375 8.00037 8.4375C8.76624 8.4375 9.44739 8.80676 9.87537 9.37659C10.3033 8.80676 10.9845 8.4375 11.7504 8.4375C13.0427 8.4375 14.0941 9.48889 14.0941 10.7812C14.0941 10.9418 14.0779 11.0985 14.047 11.25H15.5316C15.7905 11.25 16.0004 11.0402 16.0004 10.7812V8.90625C16.0004 8.13086 15.3695 7.5 14.5941 7.5Z"
        fill="#242424"
        {...props}
      />
      <path
        d="M5.65662 1.40625C5.65662 0.630859 5.02576 0 4.25037 0C3.47498 0 2.84412 0.630859 2.84412 1.40625C2.84412 2.18164 3.47498 2.8125 4.25037 2.8125C5.02576 2.8125 5.65662 2.18164 5.65662 1.40625Z"
        fill="#242424"
        {...props}
      />
      <path
        d="M9.40662 1.40625C9.40662 0.630859 8.77576 0 8.00037 0C7.22498 0 6.59412 0.630859 6.59412 1.40625C6.59412 2.18164 7.22498 2.8125 8.00037 2.8125C8.77576 2.8125 9.40662 2.18164 9.40662 1.40625Z"
        fill="#242424"
        {...props}
      />
      <path
        d="M13.1566 1.40625C13.1566 0.630859 12.5258 0 11.7504 0C10.975 0 10.3441 0.630859 10.3441 1.40625C10.3441 2.18164 10.975 2.8125 11.7504 2.8125C12.5258 2.8125 13.1566 2.18164 13.1566 1.40625Z"
        fill="#242424"
        {...props}
      />
      <path
        d="M2.37531 3.75C3.14117 3.75 3.82233 4.11926 4.25031 4.68909C4.67828 4.11926 5.35944 3.75 6.12531 3.75C6.89117 3.75 7.57233 4.11926 8.00031 4.68909C8.42828 4.11926 9.10944 3.75 9.87531 3.75C10.6412 3.75 11.3223 4.11926 11.7503 4.68909C12.1783 4.11926 12.8594 3.75 13.6253 3.75C13.7604 3.75 13.894 3.76196 14.0251 3.7843C13.8415 3.22095 13.3116 2.8125 12.6878 2.8125H10.8128C10.4529 2.8125 10.1243 2.94861 9.87531 3.17175C9.62628 2.94861 9.29767 2.8125 8.93781 2.8125H7.06281C6.70294 2.8125 6.37433 2.94861 6.12531 3.17175C5.87628 2.94861 5.54767 2.8125 5.18781 2.8125H3.31281C2.68878 2.8125 2.15863 3.22119 1.9754 3.78479C2.10541 3.76233 2.23895 3.75 2.37531 3.75Z"
        fill="#242424"
        {...props}
      />
      <defs>
        <clipPath id="clip0_77_7146">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
